import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-346c57e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "normal-header task" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", null, "Tasks")
  ])
], -1))
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "entry" }
const _hoisted_4 = { class: "normal-header" }
const _hoisted_5 = { class: "task" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))

import { AssetManagementPlan, RACIRole, RACITask } from "@/classes";
import { RACIValue } from "@/classes/asset-management-plan";
import RoleAutocomplete from "../RoleAutocomplete.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RACIMatrix',
  props: {
    plan: {},
    readonly: { type: Boolean }
  },
  emits: ["add:task", "add:role", "delete:task", "delete:role", "set:raci"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const getRACI = (task: RACITask, role: RACIRole) => {
  const data = props.plan?.raci_data.find(
    (d) => d.raci_role_id === role.id && d.raci_task_id === task.id,
  );

  if (data) {
    switch (data.value) {
      case "R":
        return { color: "blue", text: "R" };
      case "A":
        return { color: "red", text: "A" };
      case "C":
        return { color: "green", text: "C" };
      case "I":
        return { color: "black", text: "I" };
      default:
        return { color: "", text: "" };
    }
  } else {
    return { color: "", text: "" };
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    variant: "outlined",
    rounded: "lg",
    class: "raci-table"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar, { density: "compact" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [
              _createTextVNode("2.1.1 RACI Matrix")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_table, {
        "fixed-header": "",
        density: "compact"
      }, {
        default: _withCtx(() => [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_1,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plan?.raci_roles ?? [], (role) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: role.id,
                  class: "rotated-header"
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, [
                      _createVNode(RoleAutocomplete, {
                        modelValue: role.role_id,
                        "onUpdate:modelValue": ($event: any) => ((role.role_id) = $event),
                        class: "role",
                        readonly: _ctx.readonly
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                    ])
                  ])
                ]))
              }), 128)),
              _createElementVNode("th", _hoisted_4, [
                (!_ctx.readonly)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "ml-4",
                      icon: "mdi-plus",
                      variant: "plain",
                      density: "compact",
                      color: "secondary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('add:role')))
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plan?.raci_tasks ?? [], (task) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: task.id
              }, [
                _createElementVNode("th", _hoisted_5, [
                  _createVNode(_component_v_text_field, {
                    modelValue: task.name,
                    "onUpdate:modelValue": ($event: any) => ((task.name) = $event),
                    density: "compact",
                    "hide-details": "",
                    variant: "plain",
                    placeholder: "Task",
                    readonly: _ctx.readonly
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plan?.raci_roles ?? [], (role) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: role.id,
                    class: "pa-0"
                  }, [
                    _createVNode(_component_v_menu, null, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps({
                          variant: "text",
                          class: "raci-value",
                          color: getRACI(task, role).color,
                          ref_for: true
                        }, props, { readonly: _ctx.readonly }), {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getRACI(task, role).text), 1)
                          ]),
                          _: 2
                        }, 1040, ["color", "readonly"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, {
                              title: "",
                              onClick: ($event: any) => (emit('set:raci', { task, role, value: null }))
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_v_list_item, {
                              title: "Responsible",
                              "base-color": "blue",
                              onClick: ($event: any) => (emit('set:raci', { task, role, value: 'R' }))
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_v_list_item, {
                              title: "Accountable",
                              "base-color": "red",
                              onClick: ($event: any) => (emit('set:raci', { task, role, value: 'A' }))
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_v_list_item, {
                              title: "Consulted",
                              "base-color": "green",
                              onClick: ($event: any) => (emit('set:raci', { task, role, value: 'C' }))
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_v_list_item, {
                              title: "Informed",
                              "base-color": "black",
                              onClick: ($event: any) => (emit('set:raci', { task, role, value: 'I' }))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128)),
                _createElementVNode("td", null, [
                  (!_ctx.readonly)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        icon: "mdi-delete",
                        variant: "plain",
                        density: "compact",
                        color: "red",
                        onClick: ($event: any) => (emit('delete:task', task))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128)),
            (!_ctx.readonly)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                  _createElementVNode("th", null, [
                    _createVNode(_component_v_btn, {
                      icon: "mdi-plus",
                      variant: "plain",
                      density: "compact",
                      color: "secondary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('add:task')))
                    })
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plan?.raci_roles ?? [], (role) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: role.id
                    }, [
                      _createVNode(_component_v_btn, {
                        icon: "mdi-delete",
                        variant: "plain",
                        density: "compact",
                        color: "red",
                        onClick: ($event: any) => (emit('delete:role', role))
                      }, null, 8, ["onClick"])
                    ]))
                  }), 128)),
                  _hoisted_7
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})